import React, { useEffect, useRef, useState } from "react";
import {
  ChevronLeftIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/24/outline";
import { BsPersonLinesFill } from "react-icons/bs";
import logo from "../assets/Logo icon.png";
import io from "socket.io-client";
import DOMPurify from "dompurify";
import { useDispatch, useSelector } from "react-redux";
import {
  updateConvoMessage,
  updateConvoStatus,
} from "../Redux/Actions/convoActions";

const socket = io(`${process.env.REACT_APP_CHAT_SERVER}`);

function Convo({ setView, setActiveIcon, setupDetails }) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [attachmentType, setAttachmentType] = useState(null);
  const [smooth, setSmooth] = useState(false);
  const convo = useSelector((state) => state.convo);
  const dispatch = useDispatch();

  const messagesEndRef = useRef(null);
  const scrollToBottom = (smooth) => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: smooth ? "smooth" : "auto",
      });
    }
  };

  useEffect(() => {
    setSmooth(true);
  }, []);

  useEffect(() => {
    scrollToBottom(smooth);
  }, [convo?.messages]);

  const getRawText = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || doc.body.innerText || "";
  };

  const removeQuotedText = (message) => {
    const quotedTextPattern =
      /(?:^On .+ wrote:|^From: .+|^\s*>.*(?:\n|$)|^>.*(?:\n|$))/gms;
    const result = message.replace(quotedTextPattern, "").trim();

    return getRawText(result);
  };

  useEffect(() => {
    const handleMessage = (messageData) => {
      console.log({ messageData });
    };

    socket.on("receiveMessage", handleMessage);

    socket.on("message", (message) => {
      console.log({ message });
      console.log({ convo });
      dispatch(updateConvoMessage(message));
    });

    socket.on("ticketStatusUpdated", (response) => {
      dispatch(updateConvoStatus(response.status));
    });

    return () => {
      socket.off("message");
      socket.off("ticketStatusUpdated");
    };
  }, [convo]);

  useEffect(() => {
    if (convo) {
      socket.on("connect", () => {
        const allRoomIds = [convo.roomId];
        socket.emit("join", allRoomIds);
      });
    }
  }, [convo]);

  const sendMessage = () => {
    if (convo === null) {
      console.error("Can not send message, convo missing!");
      return;
    }
    const inputMessage = message.trim();
    if (inputMessage || (attachment && attachmentType)) {
      const msg = {
        room: convo.roomId,
        sender: "Customer",
        senderId: "",
        message: inputMessage === "" ? null : inputMessage,
        attachment,
        attachmentType,
      };
      socket.emit("message", msg);
      setMessage("");
      setAttachment(null);
      setAttachmentType(null);
    }
  };

  return (
    <div className="flex flex-col h-screen">
      <div className="relative mt-4 flex-grow">
        <div>
          <ChevronLeftIcon
            onClick={() => {
              setView("LandingWindow");
              setActiveIcon("home");
            }}
            className="w-5 h-5 text-blue-800 absolute left-3 cursor-pointer"
          />
          <div
            style={{
              background: `linear-gradient(90deg, ${
                setupDetails?.widgetCustomizations?.primaryColor || "#4c73de"
              } 0%,  ${
                setupDetails?.widgetCustomizations?.secondaryColor || "#2a4dad"
              } 100%)`,
              backgroundClip: "text",
              color: "transparent",
              fontWeight: "bold",
            }}
            className="text-blue-800 font-semibold text-base mb-4"
          >
            Convo
          </div>
        </div>

        <hr></hr>
        <div
          style={{
            overflowY: "auto",
            maxHeight: "62vh",
            width: "100%",
            msOverflowStyle: "none", // For IE and Edge
            scrollbarWidth: "none", // For Firefox
          }}
        >
          <div className="flex flex-col items-center">
            <div className="flex items-center">
              <BsPersonLinesFill
                className="w-14 h-14 mr-1"
                style={{
                  color: setupDetails?.widgetCustomizations?.primaryColor,
                }}
              />

              <div className="h-2 w-2 mr-2 bg-green-500 rounded-xl"></div>
              <div className="text-sm font-semibold">Live agent</div>
            </div>
          </div>
          <div className="flex">
            <BsPersonLinesFill
              className="w-7 h-7 mt-auto mr-1"
              style={{
                color: setupDetails?.widgetCustomizations?.primaryColor,
              }}
            />
            <div>
              <div className="border rounded-xl font-normal text-xs text-black bg-gray-200 p-3 w-72 text-start">
                Hi, welcome to DexKor,
                <span className="block mt-4">
                  You’re speaking with Live Agent - I’m here to answer your
                  questions.You can also talk to the team if you need to.
                </span>
              </div>
              <div className="flex justify-start items-center gap-0 mt-2">
                <div className="flex border rounded-e-xl rounded-t-xl font-normal text-xs text-black bg-gray-200 p-2 text-start">
                  <span className="text-xs">How can i help?</span>
                  {convo && (
                    <p className="text-xs text-gray-500 ml-1   mb-0 mt-1">
                      {new Date(convo?.createdAt).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {convo &&
            convo.messages.map(
              (msg, index) =>
                msg.type !== "Internal" &&
                msg.message &&
                (msg.sender === "Customer" ? (
                  <div
                    key={index}
                    className="flex justify-end ml-[20%] items-center mt-2"
                  >
                    <div
                      style={{
                        background: `linear-gradient(90deg, ${
                          setupDetails?.widgetCustomizations?.primaryColor ||
                          "#4c73de"
                        } 0%,  ${
                          setupDetails?.widgetCustomizations?.secondaryColor ||
                          "#2a4dad"
                        } 100%)`,
                        backgroundClip: "text",
                        color: "transparent",
                      }}
                      className={`font-normal text-sm text-black text-start border p-2 rounded-s-xl ${
                        convo.messages[index + 1]?.sender === msg.sender &&
                        "rounded-b-xl"
                      } rounded-t-xl bg-blue-200 break-words whitespace-normal relative min-w-[6vw] mr-2`}
                    >
                      <span
                        className="pr-14"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            removeQuotedText(msg.message)
                          ),
                        }}
                      ></span>
                      <span className="text-xs text-gray-500 absolute bottom-1 right-1 whitespace-nowrap">
                        {new Date(msg.timestamp).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div key={index} className="flex items-center">
                    {convo.messages[index + 1]?.sender !== msg.sender ? (
                      <BsPersonLinesFill
                        className="w-7 h-7 mt-auto mr-1"
                        style={{
                          color:
                            setupDetails?.widgetCustomizations?.primaryColor,
                        }}
                      />
                    ) : (
                      <div className="w-10 h-10 mt-auto"></div>
                    )}
                    <div
                      key={index}
                      className="flex justify-start items-center mt-2"
                    >
                      <div
                        className={`ml-0 font-normal text-sm text-black text-start border p-2 rounded-e-xl ${
                          convo.messages[index + 1]?.sender === msg.sender &&
                          "rounded-b-xl"
                        } rounded-t-xl bg-gray-200 break-words whitespace-normal relative min-w-[6vw]`}
                      >
                        <span
                          className="pr-14"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              removeQuotedText(msg.message)
                            ),
                          }}
                        ></span>
                        <span className="text-xs text-gray-500 absolute bottom-1 right-1 whitespace-nowrap">
                          {new Date(msg.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
            )}

          {/* Dummy div to scroll into view */}
          <div ref={messagesEndRef}></div>
        </div>
      </div>
      <div className="relative mb-4">
        <input
          type="text"
          placeholder="Ask me anything"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{
            borderColor: `linear-gradient(90deg, ${setupDetails?.widgetCustomizations?.primaryColor} 0%,  ${setupDetails?.widgetCustomizations?.secondaryColor} 100%)`,
            color: setupDetails?.widgetCustomizations?.primaryColor,
          }}
          className="text-xs bg-transparent border border-blue-900 rounded-2xl p-5 pr-12 w-full "
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              sendMessage();
              e.preventDefault(); // Prevent newline insertion
            }
          }}
        />

        <div className="absolute inset-y-0 right-0 flex items-center pr-2">
          <PaperAirplaneIcon
            onClick={() => sendMessage()}
            style={{
              color: setupDetails?.widgetCustomizations?.primaryColor,
            }}
            className="w-6 h-6 text-blue-900 cursor-pointer mr-2"
          />
        </div>
      </div>
    </div>
  );
}

export default Convo;
